import { render, staticRenderFns } from "./create-order-address-modal.vue?vue&type=template&id=06d0f49d&"
import script from "./create-order-address-modal.vue?vue&type=script&lang=js&"
export * from "./create-order-address-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports